import React, { useState } from "react";
import { useAPI } from "../Context/MyContext";

const ImageTesting = () => {
  const { createImageTemplate } = useAPI(); // Assuming createImageTemplate is an API function from context
  const [uploadHandle, setUploadHandle] = useState("");
  const [uploadPreview, setUploadPreview] = useState(null);

  const handleHeaderImageUpload = (e) => {
    const file = e.target.files[0];
    // console.log("Selected file:", file);

    if (!file) return;

    if (!file.type.startsWith("image/") || file.size > 10 * 1024 * 1024) {
      alert("Only image files up to 10MB are allowed.");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);  // Correct key for the file (image)

    // Call the createImageTemplate function from context
    createImageTemplate(formData)
      .then((result) => {
        // console.log("Success result:", result.upload_handle);
        setUploadHandle(result.upload_handle); // Save the handle for later use
        const reader = new FileReader();
        reader.onloadend = () => {
          setUploadPreview(reader.result);
        };
        reader.readAsDataURL(file);

        alert("Image uploaded successfully!");
      })
      .catch((err) => {
        console.error("Image upload error:", err);
        alert("Image upload failed.");
      });
  };

  return (
    <div className="mb-4">
      <label className="block font-medium mb-2">Upload Header Image</label>
      <input type="file" accept="image/*" onChange={handleHeaderImageUpload} />
      {uploadPreview && (
        <img
          src={uploadPreview}
          alt="Uploaded Preview"
          className="mt-2 w-40 h-auto border rounded"
        />
      )}
      {uploadHandle && (
        <p className="text-green-600 mt-1 text-sm">
          Handle stored successfully
        </p>
      )}
    </div>
  );
};

export default ImageTesting;
